export default __webpack_public_path__ + "static/media/person.3a37aa30.svg";